let autoOpened = false;
function initFilterModal() {
  const modal = document.getElementById("filterModal");
  const openBtn = document.getElementById("filterToggleBtn");
  const closeBtn = document.getElementById("filterModalClose");

  const isMobile = window.innerWidth < 990;

  // first remove any old listeners (to avoid duplicates)
  openBtn?.removeEventListener("click", openHandler);
  closeBtn?.removeEventListener("click", closeHandler);
  modal?.removeEventListener("click", outsideHandler);

  openBtn?.addEventListener("click", openHandler);
  closeBtn?.addEventListener("click", closeHandler);
  modal?.addEventListener("click", outsideHandler);

  function openHandler() {
    modal?.classList.add("open");
    autoOpened = true;
  }
  function closeHandler() {
    modal?.classList.remove("open");
    autoOpened = false;
  }
  function outsideHandler(e) {
    if (e.target === modal) modal.classList.remove("open");
  }
  
  if(isMobile && autoOpened) {
    modal?.classList.add("open");
  }
}

function initHideAdOnFiltering() {
  const collectionAds = document.querySelectorAll(".collection-ad");
  const collectionGrid = document.querySelector(".custom-collection-grid");
  if (!collectionAds.length) return;

  const url = new URL(window.location.href);
  // Look for any query-param key that begins with "filter."
  const hasFilterParam = Array.from(url.searchParams.keys()).some((key) =>
    key.startsWith("filter.")
  );

  if (hasFilterParam) {
    collectionAds.forEach((ad) => ad.classList.add("hidden"));
    collectionGrid.style.paddingBottom = "50px";
  } else {
    collectionAds.forEach((ad) => ad.classList.remove("hidden"));
    collectionGrid.style.paddingBottom = "";
  }
}

// on initial load
document.addEventListener("DOMContentLoaded", initFilterModal);
document.addEventListener("collection:reloaded", initFilterModal);
document.addEventListener("DOMContentLoaded", initHideAdOnFiltering);
document.addEventListener("collection:reloaded", initHideAdOnFiltering);

function repositionAds() {
  if (window.innerWidth >= 768) return;

  const grid = document.querySelector(".custom-collection-grid");
  if (!grid) return;

  const mobileCols = 2;

  // get only the product cards (exclude ads)
  const products = Array.from(grid.children).filter(
    (el) => !el.classList.contains("collection-ad")
  );

  grid.querySelectorAll(".collection-ad[data-ad-pos]").forEach((ad) => {
    const desktopPos = parseInt(ad.dataset.adPos, 10);

    // calculate which *mobile* row it should be in:
    // rows are 0‑based:
    //   rowIndex = ceil(desktopPos / mobileCols) - 1
    const rowIndex = Math.ceil(desktopPos / mobileCols) - 1;

    // insertion point = start of that row = rowIndex * mobileCols
    const insertionIndex = rowIndex * mobileCols;

    // clamp so we never run past the end
    const safeIndex = Math.min(insertionIndex, products.length);

    // find the node we want to insert *before*
    const refNode = products[safeIndex] || null;

    grid.insertBefore(ad, refNode);
  });
}

window.addEventListener("DOMContentLoaded", repositionAds);
window.addEventListener("resize", repositionAds);
document.addEventListener("collection:loaded-more", repositionAds);

// Lift the floating widgets (Iubenda privacy badge, KromaBot launcher) clear of
// whichever fixed bottom CTA bar is on screen. The product sticky add-to-cart
// shows on desktop too; the other bars are mobile-only. Neither widget is
// reachable from custom-style.css: the KromaBot launcher lives in a shadow root,
// and Iubenda pins `transform: none !important` on its badge from a selector we
// can't outrank, so both are driven from here instead.

// The BYOB quick-view modal's own fixed CTA strip is deliberately absent: it
// only exists on bundle-builder pages, where .byob-mobile-bar is always taller.
const BOTTOM_BAR_SELECTOR = [
  ".landing-page--sticky-add-to-cart",
  "landing-page-sticky-add-to-cart",
  ".reset-v2-sticky",
  ".byob-mobile-bar",
  ".pq-nav",
].join(",");

const BOTTOM_BAR_GAP = 12;
const IUBENDA_BADGE_SELECTOR = ".iubenda-tp-btn.iubenda-cs-preferences-link";
const KROMABOT_STYLE_ID = "kroma-bottom-bar-offset";

// Custom properties do cross the shadow boundary, so this rule can read the
// variable published on <html>. Scoped to :not(.kb-open) because the open panel
// is nearly full-height and anchors off the same `bottom`, and it shifts
// `bottom` rather than `transform` because .kb-launcher animates its own
// transform on hover and active.
const KROMABOT_CSS = `.kb-wrap:not(.kb-open){
  bottom: calc(var(--kb-edge) + var(--kroma-bottom-bar-offset, 0px)) !important;
  transition: bottom 0.25s ease;
}`;

let bottomBarOffset = null;
let iubendaBadge = null;
let bottomBarFrame = null;
let iubendaBadgeZIndex = null;

function isVisuallyHidden(element) {
  const style = getComputedStyle(element);
  return (
    style.display === "none" ||
    style.visibility === "hidden" ||
    parseFloat(style.opacity) === 0
  );
}

// How far the tallest bottom bar intrudes into the viewport. Bars parked
// off-screen (e.g. translateY(100%)) have a top at or below the fold, so they
// measure zero without us needing to know how each one toggles itself.
function measureBottomBarOffset() {
  let intrusion = 0;
  let quizIntrusion = 0;
  const mobile = window.matchMedia("(max-width: 767px)").matches;

  document.querySelectorAll(BOTTOM_BAR_SELECTOR).forEach((bar) => {
    const rect = bar.getBoundingClientRect();
    if (!rect.height || isVisuallyHidden(bar)) return;
    const amount = window.innerHeight - rect.top;
    const stickyAddToCart =
      bar.classList.contains("landing-page--sticky-add-to-cart") ||
      bar.tagName === "LANDING-PAGE-STICKY-ADD-TO-CART";

    if (bar.classList.contains("pq-nav")) {
      quizIntrusion = Math.max(quizIntrusion, amount);
    } else if (mobile || stickyAddToCart) {
      intrusion = Math.max(intrusion, amount);
    }
  });

  const total = intrusion + quizIntrusion;
  if (total <= 0) return 0;
  // Rounded so sub-pixel jitter mid-transition doesn't churn the style writes.
  return Math.round(Math.min(total + BOTTOM_BAR_GAP, window.innerHeight / 2));
}

function pinQuizWidgets() {
  if (!document.body.classList.contains("template-quiz")) return;
  document
    .querySelectorAll(
      ".iubenda-tp-btn, .acsb-trigger, #rebuy-bubble-global-alert-modal"
    )
    .forEach((el) => {
      el.style.setProperty("z-index", "5", "important");
    });
}

function applyBottomBarOffset() {
  bottomBarFrame = null;
  pinQuizWidgets();

  const offset = measureBottomBarOffset();

  // Iubenda re-renders its badge, so a new node has to be re-styled even when
  // the measurement itself hasn't moved.
  const badge = document.querySelector(IUBENDA_BADGE_SELECTOR);
  if (offset === bottomBarOffset && badge === iubendaBadge) return;
  bottomBarOffset = offset;
  iubendaBadge = badge;

  document.documentElement.style.setProperty(
    "--kroma-bottom-bar-offset",
    `${offset}px`
  );

  if (!badge) return;
  const onQuiz = document.body.classList.contains("template-quiz");
  if (onQuiz) {
    badge.style.setProperty("z-index", "5", "important");
  }
  if (!offset) {
    badge.style.removeProperty("transform");
    badge.style.removeProperty("transition");
    return;
  }
  // Inline !important is the only way past Iubenda's own !important declarations.
  badge.style.setProperty("transform", `translateY(-${offset}px)`, "important");
  badge.style.setProperty("transition", "transform 0.25s ease", "important");
}

function scheduleBottomBarOffset() {
  if (bottomBarFrame !== null) return;
  bottomBarFrame = requestAnimationFrame(applyBottomBarOffset);
}

// Iubenda parks its badge at z-index 2147483647, the 32-bit maximum, so the chat
// panel cannot be raised over it. Instead the badge drops just below the panel
// while it's open, and gets its own value back afterwards.
function setBadgeBehindChat(chatWrap, isOpen) {
  const badge = document.querySelector(IUBENDA_BADGE_SELECTOR);
  if (!badge) return;

  if (isOpen) {
    if (iubendaBadgeZIndex === null) {
      iubendaBadgeZIndex = {
        value: badge.style.getPropertyValue("z-index"),
        priority: badge.style.getPropertyPriority("z-index"),
      };
    }
    const chatZIndex = parseInt(getComputedStyle(chatWrap).zIndex, 10);
    badge.style.setProperty("z-index", `${chatZIndex - 1}`, "important");
    return;
  }

  if (iubendaBadgeZIndex === null) return;
  badge.style.setProperty(
    "z-index",
    iubendaBadgeZIndex.value,
    iubendaBadgeZIndex.priority
  );
  iubendaBadgeZIndex = null;
}

function setupKromabot() {
  const shadow = document.getElementById("kromabot-widget")?.shadowRoot;
  if (!shadow || shadow.getElementById(KROMABOT_STYLE_ID)) return;

  const wrap = shadow.querySelector(".kb-wrap");
  if (!wrap) return;

  const style = document.createElement("style");
  style.id = KROMABOT_STYLE_ID;
  style.textContent = KROMABOT_CSS;
  shadow.appendChild(style);

  // Shadow-root mutations never reach the <body> observer, so the open/close
  // class has to be watched from in here.
  const syncBadgeStacking = () =>
    setBadgeBehindChat(wrap, wrap.classList.contains("kb-open"));
  new MutationObserver(syncBadgeStacking).observe(wrap, {
    attributes: true,
    attributeFilter: ["class"],
  });
  syncBadgeStacking();
}

function initBottomBarOffset() {
  setupKromabot();
  applyBottomBarOffset();

  window.addEventListener("scroll", scheduleBottomBarOffset, { passive: true });
  window.addEventListener("resize", scheduleBottomBarOffset);

  // The bars toggle via data attributes, classes, inline styles and the hidden
  // attribute, and the BYOB bar, the KromaBot host and the Iubenda badge are all
  // appended to <body> after load, so watch for all of it rather than per-bar hooks.
  new MutationObserver(() => {
    setupKromabot();
    scheduleBottomBarOffset();
  }).observe(document.body, {
    attributes: true,
    attributeFilter: [
      "class",
      "style",
      "hidden",
      "data-visible",
      "data-sticky-visible",
    ],
    childList: true,
    subtree: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBottomBarOffset);
} else {
  initBottomBarOffset();
}
